/**
 * security模块接口列表
 */
import $http from '../utils/http'// 导入http中创建的axios实例

const security = {
  // 查菜单接口
  userMenu(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/security/userMenu`,param);
  },
  //角色列表分页
  pageRole(params) {
    return $http.post(`${global.API_URL}/sme/security/rolePage`,params);
  },
  //角色删除
  deleteRole(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/security/roleDelete`,param);
  },
  //角色名称重复检查
  roleNameCheck(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/security/roleNameCheck`,param);
  },
  //开启或关闭state
  changeStatus(params) {
    return $http.post(`${global.API_URL}/sme/security/changeStatus`,params);
  },
  //查询菜单模块
  menuTreeNode(params) {
    // let param = new URLSearchParams();
    // param.append(id, params);
    return $http.post(`${global.API_URL}/sme/security/menuTreeNode?userName=${params.userName}&companyId=${params.companyId}`);
  },
  menuTreeNodeEdit(params) {
    // let param = new URLSearchParams();
    // param.append(id, params);
    return $http.post(`${global.API_URL}/sme/security/menuTreeNode?roleId=${params.roleId}&companyId=${params.companyId}`);
  },
  //添加角色
  createRole(params) {
    return $http.post(`${global.API_URL}/sme/security/createRole`,params);
  },
  //根据角色ID查询详细信息
  select(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/security/select`,param);
  },
   //编辑角色
  updateRole(params) {
    return $http.post(`${global.API_URL}/sme/security/updateRole`,params);
  }
}

export default security



// WEBPACK FOOTER //
// ./src/api/security.js